// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section_Section__ZJPBS","OpenSection":"Section_OpenSection__Oi3yr","Icon":"Section_Icon__XK93x","ExpandedMenu":"Section_ExpandedMenu__3pD7k"};